/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:24/06/2021
 @Time:15:48
 **/


import TranslationService from "../../i18n/service/TranslationService";

$(function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })
});

// changer langue
$(function(){
    $("#choix-langue").on('changed.bs.select', function(e, clickedIndex, isSelected, previousValue) {
        window.location=$(this).find('option').eq(clickedIndex).val();
    });
});


//accordian start
$(function(){
    $('.tab-wrapper.v1 .item .tab-btn a').click(function(e){
        e.preventDefault();

        var _item     = $(this).closest('.item');
        var _hasClass = 'selected';
        var _all      = $('.tab-wrapper.v1 .item');

        if(_item.hasClass(_hasClass)){
            _item.find('.tab-btn a em').removeClass('mdi-minus').addClass('mdi-plus')
                .closest('.item')
                .find('.tab-content')
                .stop()
                .slideUp(400, function(){
                    _item.removeClass('selected');
                });

        }else{
            _all.find('.tab-btn a em').removeClass('mdi-minus').addClass('mdi-plus')
                .closest('.item')
                .find('.tab-content')
                .stop()
                .slideUp(400, function(){
                    _all.removeClass('selected');
                });

            _item.find('.tab-btn a em').removeClass('mdi-plus').addClass('mdi-minus')
                .closest('.item')
                .find('.tab-content')
                .stop()
                .slideDown(400, function(){
                    _item.addClass('selected');
                });
        }
    });

    $('.tab-wrapper.v2 .tab-btn a').click(function(e){
        e.preventDefault();

        var _this       = $(this);
        var _hasClass   = 'selected';
        var _category   = _this.data('category');
        var _content    = $('.tab-wrapper.v2 .tab-content .item');
        var _all        = $('.tab-wrapper.v2 .tab-btn a');

        if(_this.hasClass(_hasClass)){

        }else{
            _all.removeClass(_hasClass).find('em').removeClass('mdi-minus').addClass('mdi-plus');
            _this.addClass(_hasClass).find('em').removeClass('mdi-plus').addClass('mdi-minus');

            _content.each(function(){
                var _value   = $(this).data('value');

                $(this).removeClass(_hasClass).stop().hide();

                if(_value == _category){
                    $(this).stop()
                        .fadeIn('slow', function(){
                            $(this).addClass(_hasClass);
                        });
                }
            });
        }

    });
});
//accordian end


$(function () {
    "use strict";
    var checkSelectorExistence = function(selectorName) {
        if(jQuery(selectorName).length > 0){return true;}else{return false;}
    };

    if(!checkSelectorExistence('.placeholdertx')){return;}
    $('.placeholdertx input, .placeholdertx textarea').focus(function(){
        $(this).parents('.form-group').addClass('focused');
    });

    $('.placeholdertx input, .placeholdertx textarea').blur(function(){
        var inputValue = $(this).val();
        if ( inputValue == "" ) {
            $(this).removeClass('filled');
            $(this).parents('.form-group').removeClass('focused');
        } else {
            $(this).addClass('filled');
        }
    });
}); // End of use strict


$(function () {
    var owlslider = jQuery("div.owl-carousel");
    owlslider.each(function () {
        var $this = $(this),
            $items = ($this.data('items')) ? $this.data('items') : 1,
            $loop = ($this.attr('data-loop')) ? $this.data('loop') : true,
            $navdots = ($this.data('nav-dots')) ? $this.data('nav-dots') : false,
            $navarrow = ($this.data('nav-arrow')) ? $this.data('nav-arrow') : false,
            $autoplay = ($this.attr('data-autoplay')) ? $this.data('autoplay') : true,
            $autohgt = ($this.data('autoheight')) ? $this.data('autoheight') : false,
            $autowdt = ($this.data('autoWidth')) ? $this.data('autoWidth') : true,
            $space = ($this.attr('data-space')) ? $this.data('space') : 20;

        $(this).owlCarousel({
            loop: $loop,
            items: $items,
            responsive: {
                0:{items: $this.data('xx-items') ? $this.data('xx-items') : 1},
                480:{items: $this.data('xs-items') ? $this.data('xs-items') : 1},
                768:{items: $this.data('sm-items') ? $this.data('sm-items') : 2},
                980:{items: $this.data('md-items') ? $this.data('md-items') : 3},
                1200:{items: $items}
            },
            dots: $navdots,
            autoHeight:$autohgt,
            margin:$space,
            nav: $navarrow,
            navText:["<i class='fa fa-angle-left fa-2x'></i>","<i class='fa fa-angle-right fa-2x'></i>"],
            autoplay: $autoplay,
            autoplayHoverPause: true,
        });
    });
});
$(function () {

    AOS.init({
        easing: 'ease-in-out-sine'
    });

});


$(document).ready(function() {
    TranslationService.getInstance().whenInitialized(translationService => {

        var options = {
            title: translationService.translate("front-office:cookie-gdpr.titre"),
            message: translationService.translate("front-office:cookie-gdpr.content"),
            delay: 600,
            expires: 1,
            link: '#privacy',
            onAccept: function(){
                var myPreferences = $.fn.ihavecookies.cookie();
                Begro.logInfo('Les préférences ont été enregistrés');
                Begro.logInfo(myPreferences);
            },
            uncheckBoxes: true,
            acceptBtnLabel: translationService.translate("front-office:action.accepter-cookie"),
            moreInfoLabel: '',
            cookieTypesTitle: translationService.translate("front-office:cookie-gdpr.message-selection"),
            fixedCookieTypeLabel: 'Essential',
            fixedCookieTypeDesc: translationService.translate("front-office:cookie-gdpr.message-essentiel-bon-fonctionnement")
        }

        $('body').ihavecookies(options);

        if ($.fn.ihavecookies.preference('marketing') === true) {
            Begro.logInfo('option Marketing est accepté');
        }

        $('#ihavecookiesBtn').on('click', function(){
            $('body').ihavecookies(options, 'reinit');
        });
    })
});